<script lang="ts">
	import { format } from 'svelte-i18n';

	import { Col, Icon, Row, Stack, Text } from '@Shelly/shelly-design-system';

	import { CAMERA_CLOUD_STORAGE_GRADIENT_END } from 'src/helpers/camera_cloud_storage_helpers';

	type Benefit = {
		title: string;
		titleDefault: string;
		subtitle: string;
		subtitleDefault: string;
	};

	const benefits: Benefit[] = [
		{
			title: 'text_camera_cloud_storage_benefit_backup_header',
			titleDefault: 'Secure, off-site video backup',
			subtitle: 'text_camera_cloud_storage_benefit_backup_subheader',
			subtitleDefault: 'Keep recordings safe in the cloud, even if the device is offline.',
		},
		{
			title: 'text_camera_cloud_storage_benefit_event_tracking_header',
			titleDefault: '24/7 event tracking',
			subtitle: 'text_camera_cloud_storage_benefit_event_tracking_subheader',
			subtitleDefault: 'Continuous capture of motion events and alerts.',
		},
		{
			title: 'text_camera_cloud_storage_benefit_video_history_header',
			titleDefault: '30 days of video history',
			subtitle: 'text_camera_cloud_storage_benefit_video_history_subheader',
			subtitleDefault: 'Browse and review up to 30 days of footage on demand.',
		},
	];
</script>

<Text styleType="body-small" class="text-uppercase text-color-muted text-bold mb-s" noWrap>
	{$format('text_premium_subheader_benefits_what_you_get', {
		default: 'What you get',
	})}
</Text>

<Stack gap="s">
	{#each benefits as benefit, index (benefit.title)}
		<Row>
			<Col sm="10" md="11">
				<Text styleType="controls-small" class="text-bold mb-xs">
					{$format(benefit.title, { default: benefit.titleDefault })}
				</Text>
				<Text styleType="body-small" class="text-color-muted">
					{$format(benefit.subtitle, { default: benefit.subtitleDefault })}
				</Text>
			</Col>
			<Col sm="2" md="1">
				<div class="ccs-benefit-check">
					<Icon
						size="s"
						icon="fas fa-check"
						style={`color: ${CAMERA_CLOUD_STORAGE_GRADIENT_END};`}
					/>
				</div>
			</Col>
			{#if index < benefits.length - 1}
				<div class="ccs-benefit-divider" />
			{/if}
		</Row>
	{/each}
</Stack>

<style>
	.ccs-benefit-row {
		display: flex;
		align-items: center;
		gap: 16px;
		padding-block: 12px;
	}

	.ccs-benefit-text {
		flex: 1;
		min-width: 0;
	}

	.ccs-benefit-check {
		display: inline-flex;
		align-items: center;
		justify-content: center;
		width: 32px;
		height: 32px;
		flex-shrink: 0;
	}

	.ccs-benefit-divider {
		height: 1px;
		background: var(--color-2, rgba(255, 255, 255, 0.08));
	}
</style>
